import UserRolesTable from "./UserRolesTable";
export default UserRolesTable;
